document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.infinite_slider_text_main').forEach(function(wrapper) {
    const container = wrapper?.querySelector(".infinite_slider_text_content");
    if (!wrapper || !container) return;

    const speed = parseFloat(wrapper.dataset.speed) || 50; 
    const direction = wrapper.dataset.direction || "left";
    const pauseOnHover = wrapper.dataset.pause === "true";

    let running = true;
    let lastTime = performance.now();
    let translate = 0;

    const wrapperWidth = wrapper.offsetWidth;
    while (container.scrollWidth < wrapperWidth * 2) {
      container.innerHTML += container.innerHTML;
    }

    function step(now) {
      if (!running) {
        requestAnimationFrame(step);
        return;
      }

      const elapsed = (now - lastTime) / 1000;
      lastTime = now;
      const distance = speed * elapsed;

      if (direction === "left") {
        translate -= distance;
        const firstCard = container.firstElementChild;
        if (firstCard) {
          const cardWidth = firstCard.offsetWidth + parseInt(getComputedStyle(container).columnGap || 0);
          if (Math.abs(translate) >= cardWidth) {
            translate += cardWidth;
            container.appendChild(firstCard);
          }
        }
        container.style.transform = `translateX(${translate}px)`;
      }

      else if (direction === "right") {
        translate += distance;
        const lastCard = container.lastElementChild;
        if (lastCard) {
          const cardWidth = lastCard.offsetWidth + parseInt(getComputedStyle(container).columnGap || 0);

          // When we’ve moved one card width to the right
          if (translate >= cardWidth) {
            // Move instantly left by card width BEFORE prepending
            translate -= cardWidth;
            container.style.transform = `translateX(${translate}px)`;

            // Now move the last card to the front (off-screen)
            container.prepend(lastCard);
          }
        }

        container.style.transform = `translateX(${translate}px)`;
      }

      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);

    if (pauseOnHover) {
      container.addEventListener("mouseenter", () => { running = false; });
      container.addEventListener("mouseleave", () => { 
        lastTime = performance.now();
        running = true;
      });
    }
  });
});